import React from 'react';

function Footer() {
    return (
        <footer className="footer">
            {/* Adınızı buraya ekleyin  */}
            <p>Bu uygulama [Adınız Soyadınız] tarafından Kampüs Film Kulübü için hazırlanmıştır.</p>
        </footer>
    );
}

export default Footer;